import { render, staticRenderFns } from "./shop-type-edit.vue?vue&type=template&id=35565567&scoped=true&"
import script from "./shop-type-edit.vue?vue&type=script&lang=js&"
export * from "./shop-type-edit.vue?vue&type=script&lang=js&"
import style0 from "./shop-type-edit.vue?vue&type=style&index=0&id=35565567&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35565567",
  null
  
)

export default component.exports